/* eslint-disable import/prefer-default-export */
export const groupConstants = {
  GET_ALL_GROUPS_REQUEST: 'GROUP_GET_ALL_GROUPS_REQUEST',
  GET_ALL_GROUPS_SUCCESS: 'GROUP_GET_ALL_GROUPS_SUCCESS',
  GET_ALL_GROUPS_FAILURE: 'GROUP_GET_ALL_GROUPS_FAILURE',

  DELETE_USER_GROUP_REQUEST: 'GROUPS_DELETE_USER_GROUP_REQUEST',
  DELETE_USER_GROUP_SUCCESS: 'GROUPS_DELETE_USER_GROUP_SUCCESS',
  DELETE_USER_GROUP_FAILURE: 'GROUPS_DELETE_USER_GROUP_FAILURE',

  UNLOAD_GROUPS: 'GROUP_UNLOAD_GROUPS',

  GETGROUPBYID_REQUEST: 'GROUP_GETGROUPBYID_REQUEST',
  GETGROUPBYID_SUCCESS: 'GROUP_GETGROUPBYID_SUCCESS',
  GETGROUPBYID_FAILURE: 'GROUP_GETGROUPBYID_FAILURE',

  SET_SELECTED_GROUP: 'GROUP_SET_SELECTED_GROUP',
  SET_SELECTED_SUBGROUP: 'GROUP_SET_SELECTED_SUBGROUP',

};
